import { AlertCircle, X } from "lucide-react";

interface FormErrorBannerProps {
  message: string | null | undefined;
  onDismiss?: () => void;
  className?: string;
}

/**
 * Form-level error banner for non-field or unmapped backend errors.
 * Renders nothing when message is falsy.
 */
export function FormErrorBanner({ message, onDismiss, className }: FormErrorBannerProps) {
  if (!message) return null;

  return (
    <div
      role="alert"
      className={[
        "flex items-start gap-2 rounded-lg border px-4 py-3 text-sm",
        "border-[var(--color-error-border)] bg-[var(--color-error-bg)] text-[var(--color-error-text)]",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <AlertCircle className="mt-0.5 size-4 shrink-0" aria-hidden />
      <p className="flex-1 whitespace-pre-line">{message}</p>
      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          aria-label="Dismiss"
          className="shrink-0 opacity-60 hover:opacity-100 transition-opacity"
        >
          <X className="size-4" />
        </button>
      )}
    </div>
  );
}
